/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'feedback-collector.anonymous': 'Esse feedback está sendo enviado de modo anônimo. A Atlassian não vai poder entrar em contato com você sobre ele',
  'feedback-collector.anonymous.title': 'Feedback anônimo',
  'feedback-collector.can-be-contacted.label': 'Sim, as equipes da Atlassian podem entrar em contato comigo para saber mais sobre minhas experiências para melhorar os produtos e serviços da Atlassian. Eu reconheço a <a>Política de Privacidade da Atlassian</a>.',
  'feedback-collector.cancel-button.label': 'Cancelar',
  'feedback-collector.default.custom.textarea.label': 'No que você está pensando?',
  'feedback-collector.enrol-in-research.label': 'Eu gostaria de participar da pesquisa de produtos',
  'feedback-collector.feedback-title': 'Compartilhe suas ideias',
  'feedback-collector.form.bug.label': 'Descrever o bug ou item',
  'feedback-collector.form.comment.label': 'Deixe a gente saber sua opinião',
  'feedback-collector.form.empty.label': 'Selecione uma opção',
  'feedback-collector.form.question.label': 'O que você gostaria de saber?',
  'feedback-collector.form.suggestion.label': 'Conte para a gente o que você acha que pode melhorar',
  'feedback-collector.option.bug.label': 'Reportar um problema',
  'feedback-collector.option.comment.label': 'Deixar um comentário',
  'feedback-collector.option.default.label': 'Selecionar feedback',
  'feedback-collector.option.default.placeholder': 'Escolha um',
  'feedback-collector.option.question.label': 'Fazer uma pergunta',
  'feedback-collector.option.suggestion.label': 'Sugerir uma melhoria',
  'feedback-collector.required.fields.summary': 'Os campos obrigatórios estão marcados com um asterisco',
  'feedback-collector.submit-button.label': 'Enviar feedback',
  'feedback-collector.success-flag.description': 'Seu feedback é importante e ajuda a gente a sempre melhorar nossos produtos.',
  'feedback-collector.success-flag.title': 'Obrigado!',
  'feedback-collector.summary-placeholder': 'Deixe a gente saber sua opinião',
  'proforma-form-builder.feedback-icon-label': 'Feedback',
  'proforma-form-builder.give-feedback': 'Enviar feedback'
};